var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InvoicesPage')
}
var staticRenderFns = []

export { render, staticRenderFns }